import React from 'react';
import Tabs from 'react-bootstrap/Tabs';

function TabsComp(props) {

    return (
        <Tabs
            defaultActiveKey={props.defaultActiveKey}
            id={props.id}
            className="custom-tabs"
            >
            {
              props.children
            }
        </Tabs>
    )
}

export default TabsComp
